import api from "./api";

// Seguridad: accesos del usuario, parametros, credenciales para acciones
// sensibles y administracion de roles y accesos.
export const getsAccesosUsuario = async (codigo) => {
    const response = await api.get("/Seguridad/GetAccesosUsuario", { params: { codigo } });

    return response.data.data || [];
}

export const getsParametros = async () => {
    const response = await api.get("/Seguridad/GetParametros");

    return response.data.data || {};
}

// El perfil del usuario que esta trabajando: su filial (con 0 ve todas las
// sedes), su nombre y sus datos. Lo usan los filtros de filial.
export const getsPerfil = async () => {
    const response = await api.get("/Usuario/Perfil");

    return response.data.data || {};
}

// Verifica las credenciales del usuario y devuelve el token de autorizacion de
// la accion (vale tres minutos). El usuario es el que aprueba, que puede ser
// distinto del que esta trabajando en el sistema. Acceso es el codigo del acceso
// que el usuario tiene que tener: si no lo tiene, la API lo rechaza.
export const verificarCredenciales = async (user, password, accion, acceso) => {
    const response = await api.post("/Seguridad/VerificarCredenciales"
        + "?accion=" + encodeURIComponent(accion == null ? "" : accion), {
            user: user,
            password: password,
            accion: accion,
            acceso: acceso == null ? "" : acceso,
        });

    return response.data.data;
}

export const getsRol = async () => {
    const response = await api.get("/Rol/GetsRol");

    return response.data.data || [];
}

export const getsAcceso = async () => {
    const response = await api.get("/Rol/GetsAcceso");

    return response.data.data || [];
}

export const getsRolAcceso = async (idRol) => {
    const response = await api.get("/Rol/GetsRolAcceso", { params: { idRol } });

    return response.data.data || [];
}

export const addUpdateRol = async (rol) => {
    const response = await api.post("/Rol/AddUpdateRol", rol);

    return response.data.data;
}

// IdEstado 2 concede el acceso al rol, 3 lo quita. Se mandan todos juntos.
export const addUpdateRolAccesos = async (idRol, accesos) => {
    const response = await api.post("/Rol/AddUpdateRolAccesos?idRol=" + idRol, accesos);

    return response.data.data;
}

export const getsUsuarioRol = async (codigo) => {
    const response = await api.get("/Rol/GetsUsuarioRol", { params: { codigo } });

    return response.data.data || [];
}

export default {
    getsAccesosUsuario,
    getsParametros,
    getsPerfil,
    verificarCredenciales,
    getsRol,
    getsAcceso,
    getsRolAcceso,
    addUpdateRol,
    addUpdateRolAccesos,
    getsUsuarioRol,
};
